import React, { Children, useContext } from "react";

import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
    useParams
} from "react-router-dom";

import LoginPage from './Pages/LoginPage';
import HomePage from './Pages/HomePage/index.jsx';
import EnviaReset from './Pages/LoginPage/enviaReset.jsx';
import ResetSenha from './Pages/Usuarios/resetsenha.jsx';
import Unidade from "./Pages/Unidade/unidade";
import Tesouraria from "./Pages/Tesouraria/Tesouraria";
import Pagamentos_online from "./Pages/Tesouraria/Pagamentos_online.jsx";
import Metas_Painel from "./Pages/Metas/metas.jsx";
import UploadGPT from "./Pages/upload_sign/uploadGPT.jsx";
import Estimativa_pagina from "./Pages/Estimativa/estimativa.jsx";
import PropostasComparativo from "./Pages/extra/extra1.jsx";
import Alunos_nao_renovados from "./Pages/Modulos/alunos_nao_renovados.jsx";
import Alunos_cancelados from "./Pages/Modulos/alunos_cancelados.jsx";
import MapaSistema from "./Pages/Modulos/mapa_sistema.jsx";
import MonitoraGeo from "./Pages/Demografia/monitora_geo.jsx";
import Meus_Alunos from "./Pages/Modulos/meus_alunos.jsx";
import PenteFinoCarteirinhas from "./Pages/Modulos/PenteFinoCarteirinhas.jsx";
import Alunos_censo from "./Pages/Modulos/alunos_censo.jsx";
import Geo_modulo_mestre from "./Pages/Modulos/geo_censo.jsx";



import { AuthProvider, AuthContext } from "./contexts/auth";

const AppRoutes = () => {
    const Private = ({ children }) => {
        const { authenticated, loading } = useContext(AuthContext);

        if (loading) {
            return <div className="loading">Carregando...</div>;
        }
        if (!authenticated) {
            return <Navigate to="/login" />
        }
        return children;
    }

    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route exact path="/login" element={<LoginPage />} />
                    <Route exact path="/enviaReset" element={<EnviaReset />} />
                    <Route exact path="/" element={<Private><HomePage /></Private>} />
                    <Route exact path="/resetSenha/:token" element={<ResetSenha />} />
                    <Route exact path="/unidade/:cod_unidade" element={<Private> <Unidade /> </Private>} />
                    <Route exact path="/tesouraria" element={<Private> <Tesouraria /> </Private>} />
                    <Route exact path="/pagamentos-online" element={<Private> <Pagamentos_online /> </Private>} />
                    <Route exact path="/metas" element={<Private> <Metas_Painel /> </Private>} />
                    <Route exact path="/upload/:cod_unidade" element={<Private> <UploadGPT /> </Private>} />
                    <Route exact path="/estimativa" element={<Private> <Estimativa_pagina /> </Private>} />
                    <Route exact path="/alunos-nao-renovados" element={<Private> <Alunos_nao_renovados /> </Private>} />
                    <Route exact path="/alunos-cancelados" element={<Private> <Alunos_cancelados /> </Private>} />
                    <Route exact path="/meus-alunos" element={<Private> <Meus_Alunos /> </Private>} />
                    <Route exact path="/mapa-sistema" element={<Private> <MapaSistema /> </Private>} />
                    <Route exact path="/pente-fino-carteirinhas" element={<Private> <PenteFinoCarteirinhas /> </Private>} />
                    <Route exact path="/monitora-geo/" element={<Private> <MonitoraGeo /> </Private>} />
                    <Route exact path="/monitora-mercado" element={<Private> <Geo_modulo_mestre /> </Private>} />
                    <Route exact path="/propostas-comparativo" element={<PropostasComparativo />} />


                </Routes>

            </AuthProvider>

        </Router>

    )
}

export default AppRoutes;